import { useQueryClient } from "@tanstack/react-query";
import { EraControllerApi, EraPostRequest } from "../../../services";
import {
  getConfigObject,
  getXtenantId,
  useMutationWithLoading,
} from "../../../utils/utils";

interface Params {
  uuid: string;
  eraPostRequest: EraPostRequest;
}

export const usePostEraClaims = () => {
  const queryClient = useQueryClient();
  return useMutationWithLoading(
    async (params: Params) =>
      new EraControllerApi(getConfigObject()).postEraClaims(
        params.uuid,
        params.eraPostRequest,
        getXtenantId()
      ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["get-all-eras"] });
        queryClient.invalidateQueries({ queryKey: ["get-era-by-uuid"] });
      },
    }
  );
};
